import Form from 'react-bootstrap/Form';

const WordSearchInput = ({ value, onChange }) => (
  <Form.Control
    type='text'
    name='word'
    placeholder='Type to search...'
    autoComplete='off'
    value={value}
    onChange={onChange}
  />
);

export default WordSearchInput;
